import React from 'react';
import project_cana from '../../assets/cana.png';
import project_scrabble from '../../assets/scrabble.png';
import portfolio from '../../assets/portfolio.png';
import comparator from '../../assets/comparator.png';
import restaurant_landing from '../../assets/restaurant_landing.png';
import restaurant_mobile from '../../assets/restaurant_mobile.png';
import restaurant_dashboard from '../../assets/restaurant_dashboard.png';
import api_restaurant from '../../assets/restaurant_api.png';
import {
  JavaIcon,
  JavascriptIcon,
  TypeScriptIcon,
  ExpressIcon,
  FirebaseIcon,
  MySqlIcon,
  PixiJSIcon,
  PostgresIcon,
  PythonIcon,
  ReactIcon,
  SpringbootIcon,
  TypeOrmIcon,
  TailwindIcon,
} from '../../assets/icons/Icons';

interface CardProjectProps {
  image: string;
  title: string;
  description: string;
  technologies: string[];
  code: string;
  demo: string;
}

const icons: any = {
  JAVASCRIPT: <JavascriptIcon />,
  TYPESCRIPT: <TypeScriptIcon />,
  JAVA: <JavaIcon />,
  REACT: <ReactIcon />,
  SPRINGBOOT: <SpringbootIcon />,
  EXPRESS: <ExpressIcon />,
  FIREBASE: <FirebaseIcon />,
  MYSQL: <MySqlIcon />,
  PIXIJS: <PixiJSIcon />,
  POSTGRES: <PostgresIcon />,
  PYTHON: <PythonIcon />,
  TYPEORM: <TypeOrmIcon />,
  TAILWIND: <TailwindIcon />,
};

const getImage: any = {
  PROJECT_CANA: project_cana,
  PROJECT_SCRABBLE: project_scrabble,
  PORTFOLIO: portfolio,
  PROJECT_COMPARATOR: comparator,
  RESTAURANT_LANDING: restaurant_landing,
  RESTAURANT_MOBILE: restaurant_mobile,
  RESTAURANT_DASHBOARD: restaurant_dashboard,
  API_RESTAURANT: api_restaurant,
};

export const CardProject = ({
  image,
  title,
  description,
  technologies,
  code,
  demo,
}: CardProjectProps) => {
  const renderTechnologies = () => {
    return technologies.map(technology => {
      return icons[technology];
    });
  };
  const renderButton = () => {
    if (code.length === 0) {
      return null;
    }

    return (
      <a
        href={code}
        className="bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded text-xs">
        CODE
      </a>
    );
  };
  return (
    <a
      href={demo}
      className="flex flex-col items-center bg-white border rounded-lg shadow-md md:flex-row md:max-w-xl hover:bg-gray-100">
      <img
        className="object-cover rounded-t-lg md:rounded-r-none md:h-full w-full md:rounded-l-lg md:w-1/3"
        src={getImage[image]}
        alt=""
      />
      <div className="flex flex-col justify-between h-full p-4 leading-normal">
        <h5 className="mb-2 text-sm md:text-md lg:text-lg font-bold tracking-tight text-gray-900">
          {title}
        </h5>
        <p className="mb-3 text-xs md:text-sm lg:text-md font-normal text-gray-700">
          {description}
        </p>
        <div className="flex flex-row justify-between items-center">
          <div className="flex flex-row gap-2">{renderTechnologies()}</div>
          {renderButton()}
        </div>
      </div>
    </a>
  );
};

export default CardProject;
